import { render, staticRenderFns } from "./SalesByUser.vue?vue&type=template&id=6e4821cb&"
import script from "./SalesByUser.vue?vue&type=script&lang=js&"
export * from "./SalesByUser.vue?vue&type=script&lang=js&"
import style0 from "./SalesByUser.vue?vue&type=style&index=0&id=6e4821cb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports